import React from "react";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { GenericListProps } from "../../types/GenericListType";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { LinkButton, LinkButtonProps } from "../../components/LinkButton";
import { Links, LinksProps } from "../../components/Links";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { List } from "../../components/List";

export interface ComplexElectricityConnectionPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  processes?: ProcessStepsProps[];
  applyButton?: LinkButtonProps;
  linksList?: LinksProps[];
  faqs?: FaqAccordionGroupProps;
}

export const ComplexElectricityConnectionPage: React.FC<ComplexElectricityConnectionPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  processes,
  applyButton,
  linksList,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {lists && lists[0] && <List {...lists[0]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {lists && lists[1] && <List {...lists[1]} />}
      {applyButton && <LinkButton {...applyButton} />}
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
